<template>
    <div>
        <ModalCompleteTicket 
            :ticket="ticket" 
            :solution_summary="solution_summary"
            @changeStatusSuccess="$emit('changeStatusSuccess', $event)"
        />
    </div>
</template>

<script>
    import ModalCompleteTicket from "./ModalCompleteTicket.vue";

    export default {
        name: "ModalStatusSuccess",
        components: {
            ModalCompleteTicket
        },
        props: {
            ticket: {
                type: Object,
                default: () => {
                    return null;
                }
            },
            solution_summary: {
                type: String,
                default: ''
            }
        }
    }
</script>

<style scoped>

</style>